import React from 'react';
import { UsersIcon } from 'lucide-react';
const SPOTS_LEFT = 9;
const FILL_PERCENT = 93;
export function ScarcityBar() {
  return <div className="rounded-xl border border-alert/40 bg-alert/10 p-4" data-id="element-236" data-mp="2yvt6ejrmzdvo">
      <div className="mb-2 flex items-center gap-2" data-id="element-237" data-mp="2l5plpx8ens8c">
        <UsersIcon className="h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-238" data-mp="2l33gw5cwfqtt" />
        <p className="text-xs font-700 uppercase tracking-wide text-white sm:text-sm" data-id="element-239" data-mp="2q26ej4qjuurr">
          Only {SPOTS_LEFT} spots left at the $27 promotional price
        </p>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-navy-950" role="progressbar" aria-valuenow={FILL_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-240" data-mp="2g6mh2dwc7o0w">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${FILL_PERCENT}%`
      }} data-id="element-241" data-mp="eyo0tkg2fnd" />
      </div>
      <p className="mt-2 text-[11px] font-medium text-slate-300" data-id="element-242" data-mp="5didv525sbl0">
        {FILL_PERCENT}% of today’s promotional spots already claimed.
      </p>
    </div>;
}